import {
  getDiffDate,
  parseFullDateFromDb,
  formatDateTimeSave,
  parseDate,
} from '../../utils/date';
import { getMarginFee } from '../../utils/helpers';
import { formatDisplayNumber } from '../../utils/format';

export const getProfitColor = (profit) => {
  let color = 'text-gray-600 dark:text-gray-300';
  if (profit > 0) {
    color = 'text-green-500';
  } else if (profit < 0) {
    color = 'text-red-700 dark:text-red-500';
  }

  return color;
};

export const getProfitBackgroundColor = (profit) => {
  let color = 'bg-gray-600 dark:bg-gray-300';
  if (profit > 0) {
    color = 'bg-green-500';
  } else if (profit < 0) {
    color = 'bg-red-700 dark:bg-red-500';
  }

  return color;
};

export const getInvestmentFee = (item) => {
  const buyValue = item.price * item.quantity;
  const currentValue = item.giadongcua * 1000 * item.quantity;
  const transferFee = (buyValue * item.feeForCompany) / 100;
  const marginFee = getMarginFee(
    item.debtMargin,
    item.marginFee,
    item.purchaseDate
  );
  let totalFee = parseFloat(
    (transferFee + marginFee + item.debtOfCustodyFeesValue).toFixed(2)
  );
  if (item.options?.isStockDividends) {
    totalFee += item.options.personalIncomeTax;
  }
  const profit = parseFloat(
    (
      currentValue -
      buyValue -
      (totalFee < 0 ? totalFee * -1 : totalFee)
    ).toFixed(2)
  );
  let percent = (profit * 100) / buyValue;
  if (item.options?.isStockDividends) {
    percent = 100;
  }
  let color = 'text-gray-600 dark:text-gray-300';
  if (profit > 0) {
    color = 'text-green-500';
  } else if (profit < 0) {
    color = 'text-red-700 dark:text-red-500';
  }
  if (totalFee > 0) {
    totalFee = totalFee * -1;
  }

  return {
    currentValue,
    day: getDiffDate(parseFullDateFromDb(item.purchaseDate)) || 1,
    feeForCompany: transferFee,
    transferFee: parseFloat(transferFee.toFixed(2)),
    debt: parseFloat(marginFee.toFixed(2)),
    totalFee,
    profit,
    profitPercent:
      parseFloat(percent.toFixed(2)) !== 0
        ? parseFloat(percent.toFixed(2))
        : 0.01,
    color,
  };
};

export const getTransferFee = (item) => {
  const buyValue = item.price * item.quantity;
  if (item.hasBroker === '1') {
    const percent = item.feeForCompany;
    return {
      percent: formatDisplayNumber(parseFloat(percent.toFixed(2)), ',', '0'),
      value: formatDisplayNumber(
        parseFloat(((buyValue * percent) / 100).toFixed(2)),
        ',',
        '0'
      ),
    };
  }

  const percent = item.feeForCompany;
  return {
    percent: formatDisplayNumber(parseFloat(percent.toFixed(2)), ',', '0'),
    value: formatDisplayNumber(
      parseFloat(((buyValue * percent) / 100).toFixed(2)),
      ',',
      '0'
    ),
  };
};

export const calcMarginFeeForOneDay = (
  loan,
  fee,
  index = null,
  rateOptions = []
) => {
  if (loan) {
    let feeValue = fee;
    const newLoan = loan.toString().replaceAll(',', '');
    if (index !== null) {
      feeValue = Number(rateOptions[index].percent);
    }
    const result = ((Number(newLoan) * feeValue) / 100 / 365)?.toFixed(2);
    return newLoan ? formatDisplayNumber(result, ',', 0) : '0';
  }
  return 0;
};

export const getMarginFeeList = (item) => {
  let result = 'NA';
  if (item.marginFee.length) {
    const defaultFee = item.marginFee.find((f) => f.type === 'default');
    if (defaultFee) {
      result = `<div><span className="font-bold">${
        defaultFee.fee
      }%/năm</span> (~${calcMarginFeeForOneDay(
        item.debtMargin,
        defaultFee.fee
      )}đ/ngày)</div>`;
    } else {
      result = `<div>${
        item.marginFee[0].day
      } ngày đầu lãi suất <span className="font-bold">${
        item.marginFee[0].fee
      }%/năm</span> (~${calcMarginFeeForOneDay(
        item.debtMargin,
        item.marginFee[0].fee
      )}đ/ngày)</div>`;

      for (let i = 1; i < item.marginFee.length - 1; i++) {
        result += `<div>${
          item.marginFee[i].day
        } ngày tiếp theo lãi xuất <span className="font-bold">${
          item.marginFee[i].fee
        }%/năm</span> (~${calcMarginFeeForOneDay(
          item.debtMargin,
          item.marginFee[i].fee
        )}đ/ngày)</div>`;
      }

      result += `<div>từ ngày thứ ${
        item.marginFee[item.marginFee.length - 1].day
      } lãi xuất <span className="font-bold">${
        item.marginFee[item.marginFee.length - 1].fee
      }%/năm</span> (~${calcMarginFeeForOneDay(
        item.debtMargin,
        item.marginFee[item.marginFee.length - 1].fee
      )}đ/ngày)</div>`;
    }
  }
  return result;
};

export const getFeeForCompany = (_quantity, _price, val) => {
  if (!_quantity || !_price) {
    return 0;
  }
  const quantity = Number(_quantity);
  const price = Number(_price);
  return parseFloat(((Number(val) * 100) / (quantity * price)).toFixed(2));
};

export const getFeeValue = (_quantity, _price, val) => {
  if (!_quantity || !_price) {
    return 0;
  }
  const quantity = Number(_quantity);
  const price = Number(_price);
  return parseFloat(((quantity * price * Number(val)) / 100).toFixed(2));
};

export const getDebtOfCustodyFees = (
  fee,
  quantity,
  startDate,
  endDate = null
) => {
  if (!fee || !quantity) {
    return 0;
  }
  let targetDate = new Date();
  if (endDate) {
    targetDate = endDate;
  }
  const day = getDiffDate(parseFullDateFromDb(startDate), targetDate) || 1;
  return (fee / 30) * Number(quantity) * day;
};

export const getTotalSellInfo = (formik) => {
  const items = formik.values.sellItems;

  if (items.length) {
    const sellQuantity = Number(formik.values.sellAllQuantity);
    const sellPrice = Number(formik.values.sellPrice);
    const transferFee = Number(formik.values.transferFee);
    const sellDate = formik.values.sellDate;
    let totalSellValue = 0;
    let totalTransferFee = 0;
    let totalPersonalIncomeTax = 0;
    let totalValue = 0;
    let totalProfit = 0;
    let totalBuyValue = 0;
    let totalDebtOfCustodyFeesValue = 0;
    let totalMarginFee = 0;
    let totalBuyFee = 0;
    let totalStockDividends = 0;
    let totalQuantity = 0;
    let taxStockDividends = 0;
    let personalIncomeTax = 0;
    if (
      items.length > 1 &&
      sellQuantity < Number(formik.values.totalQuantity)
    ) {
      let debtOfCustodyFees = 0;
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const quantity = Number(item.sellQuantity);
        const transferFeeItem = Number(item.transferFee);
        const personalIncomeTaxItem = Number(item.personalIncomeTax);

        if (quantity > 0) {
          const percent = (quantity * 100) / item.quantity;
          const debtMargin = item.debtMargin
            ? (Number(item.debtMargin) * percent) / 100
            : 0;
          const marginFee = getMarginFee(
            debtMargin,
            item.marginFee,
            item.purchaseDate,
            formatDateTimeSave(sellDate)
          );
          totalBuyValue += item.buyPice * quantity;
          totalBuyFee += item.buyFee;
          const _totalSellValue = quantity * sellPrice;
          totalSellValue += _totalSellValue;
          totalTransferFee += Number(formik.values.transferFeeValue);
          totalPersonalIncomeTax +=
            (_totalSellValue * personalIncomeTaxItem) / 100;
          totalMarginFee += marginFee;
          debtOfCustodyFees += getDebtOfCustodyFees(
            item.debtOfCustodyFees,
            quantity,
            item.purchaseDate,
            formatDateTimeSave(sellDate)
          );
          if (item.stockDividends) {
            totalStockDividends += item.quantity;
            taxStockDividends = item.personalIncomeTax;
          } else {
            personalIncomeTax = item.personalIncomeTax;
            totalQuantity += item.quantity;
          }
        }
      }
      totalDebtOfCustodyFeesValue = debtOfCustodyFees;
    } else {
      totalSellValue = parseFloat((sellQuantity * sellPrice).toFixed(2));
      let tmpMarginFee = 0;
      let debtOfCustodyFees = 0;
      const items = formik.values.sellItems;
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const percent = (Number(item.sellQuantity) * 100) / item.quantity;
        const debtMargin = item.debtMargin
          ? (Number(item.debtMargin) * percent) / 100
          : 0;
        const marginFee = getMarginFee(
          debtMargin,
          item.marginFee,
          item.purchaseDate,
          formatDateTimeSave(sellDate)
        );
        tmpMarginFee += marginFee;
        totalBuyValue += item.buyPice * item.sellQuantity;
        totalBuyFee += item.buyFee;
        const _debtOfCustodyFees = getDebtOfCustodyFees(
          item.debtOfCustodyFees,
          item.quantity,
          item.purchaseDate,
          formatDateTimeSave(sellDate)
        );
        debtOfCustodyFees += _debtOfCustodyFees;
        const _totalSellValue = item.quantity * sellPrice;
        totalPersonalIncomeTax += parseFloat(
          ((_totalSellValue * Number(item.personalIncomeTax)) / 100).toFixed(2)
        );
        if (item.stockDividends) {
          totalStockDividends += item.quantity;
          taxStockDividends = item.personalIncomeTax;
        } else {
          personalIncomeTax = item.personalIncomeTax;
          totalQuantity += item.quantity;
        }
      }
      totalTransferFee = Number(formik.values.transferFeeValue);
      totalDebtOfCustodyFeesValue = debtOfCustodyFees;
      totalMarginFee = tmpMarginFee;
    }
    totalValue =
      totalSellValue -
      (totalTransferFee +
        totalPersonalIncomeTax +
        totalMarginFee +
        totalDebtOfCustodyFeesValue);

    totalProfit = parseFloat(
      (totalValue - totalBuyValue - totalBuyFee).toFixed(2)
    );
    totalProfitPercent = parseFloat(
      ((totalProfit * 100) / (totalBuyValue + totalBuyFee)).toFixed(2)
    );
    if (totalBuyValue === 0) {
      totalProfitPercent = 100;
    }
    return {
      totalSellValue,
      totalTransferFee,
      totalPersonalIncomeTax,
      totalValue,
      totalProfit,
      totalProfitPercent,
      totalBuyValue,
      totalMarginFee,
      totalDebtOfCustodyFeesValue,
      totalBuyFee,
      personalIncomeTaxDescription: `Tổng tiền thuế TNCN: ${formatDisplayNumber(
        totalPersonalIncomeTax
      )}đ (${formatDisplayNumber(
        totalQuantity
      )}cp * ${personalIncomeTax}% + ${formatDisplayNumber(
        totalStockDividends
      )}cp(cổ tức) * ${taxStockDividends}%)`,
    };
  }
  return {
    totalSellValue: 0,
    totalTransferFee: 0,
    totalPersonalIncomeTax: 0,
    totalValue: 0,
    totalProfit: 0,
    totalProfitPercent: 0,
    totalBuyValue: 0,
    totalMarginFee: 0,
    totalDebtOfCustodyFeesValue: 0,
    totalBuyFee: 0,
    personalIncomeTaxDescription: '',
  };
};

export const generateQuantityForSellItems = (
  sellItems,
  sellAllQuantity,
  averageQuantity,
  isLoop = false
) => {
  const newAverageQuantity = averageQuantity >= 1 ? averageQuantity : 1;
  const newSellItems = [];
  let totalItems = sellItems.length;
  let remainingQuantity = sellAllQuantity - newAverageQuantity * totalItems;
  let total = sellAllQuantity;
  for (let i = 0; i < sellItems.length; i++) {
    const targetQuantity = !isLoop
      ? newAverageQuantity
      : newAverageQuantity + Number(sellItems[i].sellQuantity);

    if (total <= 0) {
      newSellItems.push({
        ...sellItems[i],
        sellQuantity: Number(sellItems[i].sellQuantity),
      });
    } else {
      if (targetQuantity <= sellItems[i].quantity) {
        newSellItems.push({
          ...sellItems[i],
          sellQuantity: targetQuantity,
        });
        if (isLoop) {
          total -= newAverageQuantity;
        }
      } else {
        newSellItems.push({
          ...sellItems[i],
          sellQuantity: Number(sellItems[i].quantity),
        });
        remainingQuantity += newAverageQuantity - sellItems[i].quantity;
        totalItems -= 1;
      }
    }
  }
  if (remainingQuantity > 0) {
    return generateQuantityForSellItems(
      newSellItems,
      remainingQuantity,
      Math.floor(remainingQuantity / totalItems),
      true
    );
  }
  return newSellItems;
};

export const transferChartData = (items, fields, range = 1) => {
  const xAxisData = [];
  const seriesPriceData = [];
  const seriesOtherData = [];
  for (let i = 0; i < items?.length; i++) {
    xAxisData.push(parseDate(items[i].DTYYYYMMDD));
    seriesPriceData.push(items[i].giadongcua);
    seriesOtherData.push(Number(items[i][fields]) / range);
  }
  return {
    xAxisData,
    seriesPriceData,
    seriesOtherData,
  };
};

const generateDebtsItem = (averageDebts, debtsItems) => {
  const newAverageDebts = averageDebts >= 1 ? averageDebts : 1;
  const newDebtsItems = [];
  let totalItems = debtsItems.length;
  let remainingDebts = 0;
  for (let i = 0; i < debtsItems.length; i++) {
    if (debtsItems[i].total > 0) {
      if (newAverageDebts < debtsItems[i].total) {
        let marginFee = debtsItems[i].marginFee - newAverageDebts;
        let debtMargin = debtsItems[i].debtMargin;
        if (debtsItems[i].marginFee <= newAverageDebts) {
          marginFee = 0;
          const leftAverageDebts = newAverageDebts - debtsItems[i].marginFee;
          if (leftAverageDebts > 0) {
            debtMargin = debtsItems[i].debtMargin - leftAverageDebts;
            if (debtsItems[i].debtMargin <= leftAverageDebts) {
              debtMargin = 0;
            }
          }
        }
        newDebtsItems.push({
          ...debtsItems[i],
          total: debtsItems[i].total - newAverageDebts,
          marginFee,
          debtMargin,
        });
      } else {
        newDebtsItems.push({
          ...debtsItems[i],
          total: 0,
          marginFee: 0,
          debtMargin: 0,
        });
        remainingDebts += newAverageDebts - debtsItems[i].total;
        totalItems -= 1;
      }
    } else {
      newDebtsItems.push({ ...debtsItems[i] });
    }
  }
  if (remainingDebts > 0) {
    return generateDebtsItem(
      Math.floor(remainingDebts / totalItems),
      newDebtsItems
    );
  }
  return newDebtsItems;
};

const getDebts = (averageDebts, debtsItems) => {
  const newAverageDebts = averageDebts >= 1 ? averageDebts : 1;
  const newDebtsItems = [];
  let totalItems = debtsItems.length;
  let remainingDebts = 0;
  for (let i = 0; i < debtsItems.length; i++) {
    if (debtsItems[i]?.debt <= 0) {
      if (newAverageDebts <= debtsItems[i].total) {
        newDebtsItems.push({
          ...debtsItems[i],
          debt: newAverageDebts,
        });
      } else {
        newDebtsItems.push({
          ...debtsItems[i],
          debt: debtsItems[i].total,
        });
        remainingDebts += newAverageDebts - debtsItems[i].total;
        totalItems -= 1;
      }
    }
  }
  if (remainingDebts > 0) {
    return generateDebtsItem(
      Math.floor(remainingDebts / totalItems),
      newDebtsItems
    );
  }
  return newDebtsItems;
};

export const generateDebtsItems = (totalValue, newsDebts) => {
  const averageDebts = Math.floor(totalValue / newsDebts.length);
  const newList = getDebts(averageDebts, newsDebts);
  let results = [];
  newList.forEach((debt) => {
    const average = Math.floor(debt.debt / debt.items.length);
    const items = generateDebtsItem(average, debt.items);
    results = [...results, ...items];
  });
  return results;
};
